/*
 * Search as you type (owner 2026-10-04: "nothing shows until you type it in and click search ... make it so that it
 * gives suggestions OR starts showing some options as you type").
 * Markup: snippets/as-search-form.liquid ([data-ps] forms) in the header overlay (sections/header.liquid) and on
 * /search (sections/main-search.liquid).
 *  - Empty box + focus: starting points (popular collections, trending searches) from sections/as-search-suggest.liquid
 *    rendered without a query.
 *  - 2+ characters, 200 ms debounce, two requests in parallel:
 *      /search/suggest.json            query suggestions, collections, pages (Shopify Predictive Search)
 *      /search?...&section_id=as-search-suggest   up to 6 products, one per AdabStars design (deduped in Liquid)
 *  - ARIA 1.2 combobox: input[role=combobox] + [role=listbox] with [role=option] links; arrow keys move,
 *    Enter opens the highlighted option (or runs the full search), Esc closes the list, then the overlay.
 *  - Without JS the forms are plain GET forms to /search and the header icon is a link to /search.
 */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MIN = 2;
  var WAIT = 200;
  var cache = {};

  function fetchText(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html,application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .catch(function (e) { delete cache[url]; throw e; });
    }
    return cache[url];
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function highlight(text, term) {
    var out = esc(text);
    var words = term.trim().split(/\s+/).filter(function (w) { return w.length > 0; })
      .map(function (w) { return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return out;
    return out.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>');
  }
  function searchUrl(term) {
    return ROOT + 'search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
  }
  function suggestUrl(term) {
    return ROOT + 'search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources%5Btype%5D=query,collection,page&resources%5Blimit%5D=4&resources%5Blimit_scope%5D=each';
  }
  function productsUrl(term) {
    return ROOT + 'search?q=' + encodeURIComponent(term) +
      '&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&section_id=as-search-suggest';
  }
  function startUrl() { return ROOT + 'search?section_id=as-search-suggest'; }
  function inner(html, sel) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(sel);
    return el ? el.innerHTML : '';
  }
  function group(id, label, body) {
    if (!body) return '';
    return '<div class="ps-group" role="group" aria-labelledby="' + id + '">' +
      '<div class="ps-group-label" id="' + id + '" role="presentation">' + esc(label) + '</div>' + body + '</div>';
  }
  var ICON_Q = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';
  var ICON_ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

  function PS(form) {
    this.form = form;
    this.id = form.getAttribute('data-ps-id') || 'ps';
    this.input = form.querySelector('input[name="q"]');
    this.panel = form.querySelector('[data-ps-panel]');
    this.list = form.querySelector('[data-ps-list]');
    this.status = form.querySelector('[data-ps-status]');
    this.clearBtn = form.querySelector('[data-ps-clear]');
    this.active = -1;
    this.term = null;
    this.timer = 0;
    this.bind();
    this.syncClear();
  }
  PS.prototype.bind = function () {
    var self = this;
    this.input.addEventListener('input', function () {
      self.syncClear();
      clearTimeout(self.timer);
      self.timer = setTimeout(function () { self.update(); }, WAIT);
    });
    this.input.addEventListener('focus', function () { self.update(); });
    this.input.addEventListener('keydown', function (e) { self.onKey(e); });
    this.form.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !self.form.contains(e.relatedTarget)) {
        setTimeout(function () { if (!self.form.contains(document.activeElement)) self.close(); }, 0);
      }
    });
    document.addEventListener('pointerdown', function (e) {
      if (!self.form.contains(e.target)) self.close();
    });
    this.list.addEventListener('mousemove', function (e) {
      var opt = e.target.closest && e.target.closest('[role="option"]');
      if (!opt) return;
      var i = self.options().indexOf(opt);
      if (i !== self.active) self.setActive(i, false);
    });
    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', function () {
        self.input.value = '';
        self.syncClear();
        self.input.focus();
        self.update();
      });
    }
    this.form.addEventListener('submit', function (e) {
      if (!self.input.value.trim()) { e.preventDefault(); self.input.focus(); }
    });
  };
  PS.prototype.syncClear = function () {
    if (this.clearBtn) this.clearBtn.hidden = !this.input.value;
  };
  PS.prototype.options = function () {
    return Array.prototype.slice.call(this.list.querySelectorAll('[role="option"]'));
  };
  PS.prototype.open = function () {
    if (!this.panel.hidden) return;
    this.panel.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    this.form.classList.add('ps-open');
  };
  PS.prototype.close = function () {
    clearTimeout(this.timer);
    if (this.panel.hidden) return;
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
    this.form.classList.remove('ps-open');
    this.active = -1;
  };
  PS.prototype.isOpen = function () { return !this.panel.hidden; };
  PS.prototype.setActive = function (i, scroll) {
    var opts = this.options();
    if (this.active > -1 && opts[this.active]) opts[this.active].setAttribute('aria-selected', 'false');
    this.active = i;
    if (i > -1 && opts[i]) {
      opts[i].setAttribute('aria-selected', 'true');
      this.input.setAttribute('aria-activedescendant', opts[i].id);
      if (scroll !== false) opts[i].scrollIntoView({ block: 'nearest' });
    } else {
      this.input.removeAttribute('aria-activedescendant');
    }
  };
  PS.prototype.onKey = function (e) {
    var opts;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (!this.isOpen()) { this.update(); return; }
      opts = this.options();
      if (!opts.length) return;
      var n = this.active + (e.key === 'ArrowDown' ? 1 : -1);
      if (n >= opts.length) n = 0;
      if (n < -1) n = opts.length - 1;
      this.setActive(n);
    } else if (e.key === 'Enter') {
      opts = this.options();
      if (this.isOpen() && this.active > -1 && opts[this.active]) {
        e.preventDefault();
        opts[this.active].click();
      }
    } else if (e.key === 'Escape') {
      if (this.isOpen()) {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      }
    } else if (e.key === 'Tab') {
      this.close();
    }
  };
  PS.prototype.paint = function (html, announce) {
    var self = this;
    var prevId = null;
    var opts = this.options();
    if (this.active > -1 && opts[this.active]) prevId = opts[this.active].getAttribute('href');
    this.list.innerHTML = html;
    // unique ids per instance (the header overlay and /search page can both be on a page)
    Array.prototype.slice.call(this.list.querySelectorAll('[id]')).forEach(function (el) {
      el.id = 'ps-' + self.id + '-' + el.id;
    });
    Array.prototype.slice.call(this.list.querySelectorAll('[aria-labelledby]')).forEach(function (el) {
      el.setAttribute('aria-labelledby', 'ps-' + self.id + '-' + el.getAttribute('aria-labelledby'));
    });
    this.active = -1;
    this.input.removeAttribute('aria-activedescendant');
    Array.prototype.slice.call(this.list.querySelectorAll('[data-ps-option]')).forEach(function (o, i) {
      o.setAttribute('role', 'option');
      o.setAttribute('tabindex', '-1');
      o.setAttribute('aria-selected', 'false');
      o.id = 'ps-' + self.id + '-opt-' + i;
      if (prevId && o.getAttribute('href') === prevId) self.setActive(i, false);
    });
    if (announce != null && this.status) this.status.textContent = announce;
    this.open();
  };
  PS.prototype.update = function () {
    var self = this;
    var term = this.input.value.trim();
    if (term.length < MIN) {
      if (this.term === '' && this.isOpen()) return;
      this.term = '';
      fetchText(startUrl()).then(function (html) {
        if (self.term !== '' || document.activeElement !== self.input) return;
        var body = inner(html, '[data-ps-start]');
        if (body) {
          self.paint('<div class="ps-start-panel">' + body + '</div>', 'Popular collections and trending searches');
          self.list.setAttribute('data-ps-term', '');
          self.list.setAttribute('aria-busy', 'false');
        }
      }).catch(function () {});
      return;
    }
    if (term === this.term && this.isOpen()) return;
    this.term = term;
    var state = { sugg: null, prods: null, sErr: false, pErr: false };
    var draw = function () { if (self.term === term) self.render(term, state); };
    fetchText(suggestUrl(term)).then(function (t) {
      try { state.sugg = JSON.parse(t).resources.results; } catch (e) { state.sErr = true; }
      draw();
    }).catch(function () { state.sErr = true; draw(); });
    fetchText(productsUrl(term)).then(function (html) {
      state.prods = inner(html, '[data-ps-products]').trim();
      draw();
    }).catch(function () { state.pErr = true; draw(); });
  };
  PS.prototype.render = function (term, st) {
    var s = st.sugg || {};
    var queries = (s.queries || []).filter(function (q) { return q.text && q.text.toLowerCase() !== term.toLowerCase(); }).slice(0, 4);
    var colls = (s.collections || []).slice(0, 3);
    var pages = (s.pages || []).slice(0, 2);
    var left = '';
    left += group('g-q', 'Suggestions', queries.map(function (q) {
      return '<a class="ps-query" href="' + esc(searchUrl(q.text)) + '">' + ICON_Q + '<span>' + highlight(q.text, term) + '</span></a>';
    }).join(''));
    left += group('g-c', 'Collections', colls.map(function (c) {
      var img = c.featured_image && c.featured_image.url
        ? '<img src="' + esc(c.featured_image.url + (c.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="" width="48" height="48" decoding="async">'
        : '';
      return '<a class="ps-coll" href="' + esc(c.url) + '"><span class="ps-coll-img">' + img + '</span><span>' + highlight(c.title, term) + '</span></a>';
    }).join(''));
    left += group('g-p', 'Pages', pages.map(function (p) {
      return '<a class="ps-query" href="' + esc(p.url) + '"><span>' + highlight(p.title, term) + '</span></a>';
    }).join(''));

    var prodBody;
    var loading = st.prods === null && !st.pErr;
    if (loading) {
      prodBody = '<div class="ps-skel" aria-hidden="true"><span></span><span></span><span></span></div>';
    } else {
      prodBody = st.prods || '';
    }
    var right = prodBody ? group('g-pr', 'Products', prodBody) : '';
    var nProds = st.prods ? (st.prods.match(/data-ps-option/g) || []).length : 0;
    var empty = !loading && st.sugg !== null && !left && !nProds;
    var html = '<div class="ps-cols' + (left ? '' : ' ps-cols--one') + '">' +
      (left ? '<div class="ps-col ps-col--left">' + left + '</div>' : '') +
      '<div class="ps-col ps-col--right">' + (empty
        ? '<p class="ps-empty">No quick matches for “' + esc(term) + '”. Try the full search or a shorter word.</p>'
        : right) + '</div></div>' +
      '<a class="ps-all" href="' + esc(searchUrl(term)) + '"><span>See all results for “<strong>' + esc(term) + '</strong>”</span>' + ICON_ARROW + '</a>';
    var count = queries.length + colls.length + pages.length + nProds;
    var msg = loading ? null : (count ? count + ' suggestions available. Use the up and down arrows to browse.' : 'No quick matches. Press Enter to search.');
    this.paint(html.replace(/<a class="(ps-query|ps-coll|ps-all)"/g, '<a data-ps-option class="$1"'), msg);
    this.list.setAttribute('data-ps-term', term);
    this.list.setAttribute('aria-busy', loading || st.sugg === null && !st.sErr ? 'true' : 'false');
  };

  // Header overlay
  function Overlay(el) {
    var self = this;
    this.el = el;
    this.form = el.querySelector('[data-ps]');
    this.input = el.querySelector('input[name="q"]');
    this.opener = null;
    Array.prototype.slice.call(document.querySelectorAll('[data-ps-open]')).forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        var pageInput = document.querySelector('[data-ps-id="page"] input[name="q"]');
        if (pageInput) {
          pageInput.scrollIntoView({ block: 'center' });
          pageInput.focus();
          return;
        }
        self.open(a);
      });
      var warm = function () { fetchText(startUrl()).catch(function () {}); };
      a.addEventListener('pointerenter', warm, { once: true });
      a.addEventListener('focus', warm, { once: true });
    });
    Array.prototype.slice.call(el.querySelectorAll('[data-ps-close]')).forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(); }
      if (e.key === 'Tab') self.trap(e);
    });
  }
  Overlay.prototype.open = function (opener) {
    this.opener = opener || null;
    this.el.hidden = false;
    document.documentElement.classList.add('ps-lock');
    if (this.opener) this.opener.setAttribute('aria-expanded', 'true');
    var input = this.input;
    requestAnimationFrame(function () { input.focus(); input.select(); });
  };
  Overlay.prototype.close = function () {
    if (this.el.hidden) return;
    this.el.hidden = true;
    document.documentElement.classList.remove('ps-lock');
    if (this.opener) { this.opener.setAttribute('aria-expanded', 'false'); this.opener.focus(); }
  };
  Overlay.prototype.trap = function (e) {
    var f = Array.prototype.slice.call(this.el.querySelectorAll('a[href], button:not([hidden]), input:not([type="hidden"])'))
      .filter(function (x) { return x.offsetParent !== null && x.getAttribute('tabindex') !== '-1'; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('form[data-ps]')).forEach(function (f) {
      if (!f.__ps) f.__ps = new PS(f);
    });
    var ov = document.querySelector('[data-ps-overlay]');
    if (ov && !ov.__ps) ov.__ps = new Overlay(ov);
    // results page: sort / filter selects apply on change
    Array.prototype.slice.call(document.querySelectorAll('[data-ps-autosubmit]')).forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
